<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    center
    :show-close="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    custom-class="centerDialogVisible centerDialogVisibleUP"
    top="30vh"
    >
    <i class="iconfont icon-icon-jiaoyiguanbi closeIcon" @click="closeIcon"></i>
    <!-- 续费套餐 7001续费，7002购买-->
    <div class="Dialogcenter">
      <div>
        <img src="@/assets/image/common/rightCard.png" alt="" class="DialogcenterrightCard">
      </div>
      <div v-if="vipCode==7002">
        <div class="DialogcenterTitle">
          购买套餐
        </div>
        <div class="DialogcenterExplain"> 
          加速你的客户开发效率
        </div>
      </div>
      <div v-if="vipCode==7001">
        <div class="DialogcenterTitle">
          您的资源包点数不足
        </div>
        <div class="DialogcenterExplain"> 
          为避免影响您的使用，您可续费购买
        </div>
      </div>
      <div class="DialogcenterBtnDiv">
        <!-- <div v-if="userInfo.leadsStatus != 8" class="DialogcenterBtnImg">
          <img src="@/assets/image/common/vip.png" alt="">
        </div>
        <div v-else class="DialogcenterBtnImg">
          <img src="@/assets/image/common/vip_expired.png" alt="">
        </div> -->
        <el-button class="DialogcenterBtn" @click="rightAway">
          <span class="DialogcenterBtnNum" style="margin-right: 20px;">
            ￥<span class="BtnNumManey" style="font-style: italic;margin-right: 2px;">{{ lowestOriginal | currency }}</span>/起
            </span>
          <!-- <span v-if="lowestTemp" class="DialogcenterBtnNum">
            ￥<span class="BtnNumManey">{{ lowestTemp | currency }}</span>起
            </span>
          <span v-if="lowestOriginal" class="DialogcenterBtnDel">￥{{ lowestOriginal | formatMoney }}起</span> -->
          <span class="DialogcenterBtnrightAway">立即购买</span>
        </el-button>
      </div>
      <div class="DialogcenterFoot">
        提供定向开发与运营海外客户的理想选择
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getSubscribeKitList } from '@/utils/api/order'
import { mapState, mapMutations } from 'vuex'

export default {
  props:{
    vipCode:{
      typeof:Number,
      default:0
    },
    typeOpen:{
      typeof:Boolean,
      default:true
    }
  },
  data(){
    return{
      centerDialogVisible: false,
      mealList: [],
      lowestOriginal: 0,  //最低档 - 原价
      lowestTemp: 0,  //最低档 - 限时优惠价
    }
  },
  computed: {
    ...mapState('orderInfo', ['packages']),
    ...mapState(['userInfo']),
  },
  methods:{
    ...mapMutations('orderInfo', ['SET_PACKAGES']),
    async initData() {
      try {
        const res = await getSubscribeKitList()
        if (res.rspResult.bizCode === 200) {
          this.mealList = res.rspListData.list
          this.SET_PACKAGES(this.mealList || null)
          this.handlePriceFn();
        }
      } catch (err) {
        console.error("❌ ~ file: VIPdialog.vue:200 ~ initData ~ err:", err)
      }
    },
    handlePriceFn() {
      if(this.mealList && this.mealList.length && this.mealList[0]) {
        // this.lowestOriginal = this.mealList[0].totalPrice || null;
        // this.lowestTemp = this.mealList[0].kitPrice || null;
        // MKP-16809单据涉及到取B套餐的价格
        this.lowestOriginal = this.mealList[1].totalPrice || null;
        this.lowestTemp = this.mealList[1].kitPrice || null;
      }
    },
    closeIcon(){
      this.centerDialogVisible =false
    },
    rightAway(){
      this.centerDialogVisible =false
      // const-center-meal-choose
      if(this.typeOpen){
        const router = this.$router.resolve({
          name: 'const-center-meal-choose'
        })
        window.location.href = router.href
        console.log('立即购买')
      }else{
        const router = this.$router.resolve({
          name: 'const-center-meal-choose'
        })
        // window.location.href = router.href
        window.open(router.href, '_blank');
      }

    },
  },
  created() {
    // 如果vuex里面有存，直接取
    // 💣💣💣价格会根据leadsStatus动态变化，所以必须每次重新请求
    if (false && this.packages && this.packages.length) {
      this.mealList = this.packages
      this.handlePriceFn();
    } else {
      this.initData()
    }
  }

}
</script>

<style lang="scss" scoped>
.Dialogcenter{
  .DialogcenterrightCard{
    position: absolute;
    top: -25px;
    width: 114px;
    height: 144px;
    right: 3px;
  }
  .DialogcenterTitle{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 24px;
    background-image: linear-gradient(136deg, #9A6000 0%, #533400 100%);
    -webkit-background-clip: text;
    color: transparent;
    letter-spacing: 0;
    text-align: center;
    text-shadow: 0 2px 4px #7e542333;
  }
  .DialogcenterExplain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #533400;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    margin-top: 5px;
    margin-bottom: 40px;
  }
  .DialogcenterBtnDiv{
    text-align: center;
    .DialogcenterBtn{
      // opacity: 0.9;
      background-image: linear-gradient(180deg, #E97E6C 0%, #E15D3F 100%);
      box-shadow: 0 2px 8px 0 #1f08004d;
      border-radius: 30.5px;
      color:#FFFFFF;
      border: none;
      width: 280px;
      height: 52px;
      margin-bottom: 16px;
      // text-align: left;
      text-align: center;
      padding: 4px;
      >span {
        display: inline-block;
        width: max-content;
      }
      .DialogcenterBtnNum{
        font-size: 12px;
        font-family: SourceHanSansCN-Regular;
        .BtnNumManey{
          font-size: 20px;
          font-weight: Bold;
        }
      }
      .DialogcenterBtnDel{
        color: rgba(255,255,255,50%);
        font-size: 12px;
        font-face: SourceHanSansCN;
        // transform: skewX(50deg);
        // text-decoration:line-through;
        margin-right: 16px;

        position: relative;
        display: inline-block;
        &::after {
          content: " ";
          position: absolute;
          width: 100%;
          top: 5px;
          left: 0;
          height: 0;
          border-bottom: 1px solid #fff;
          transform-origin: 45px 0;
          transform: rotate(-3deg);
        }
      }
      .DialogcenterBtnrightAway{
        font-family: SourceHanSansCN-Bold;
        font-weight: 700;
        font-size: 20px;
        color: #FFFFFF;
        letter-spacing: 0;
        // margin-left: 28px;
      }
    }
    .DialogcenterBtnImg{
      text-align: left;
      height: 25px;
      width: 280px;
      margin: 0 auto;
      margin-bottom: 7px;
      img{
        height: 100%;
        margin-left: 8px;
      }
    }
  }
  .DialogcenterFoot{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #533400;
    letter-spacing: 0;
    text-align: center;
  }
}
.closeIcon{
  position: absolute;
  right: -24px;
  top: 0px;
  color: #FFFFFF;
}
</style>
<style>
  .centerDialogVisible{
    width: 384px;
    /* height: 308px; */
    height: 280px;
    background-image: linear-gradient(180deg, #FAFAF4 0%, #F8EDD9 100%);
    border-radius: 30px 60px 30px 30px;
  }
  .centerDialogVisible.is-expired {
    height: 280px;
  }
</style>